// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1dL6e","col":"styles_col__1ikjD"};